import { gql } from "@apollo/client";

export const ProfileCoachingInsightFragment = gql`
  fragment ProfileCoachingInsightFragment on ManagerInsightNode {
    insightType
    title
    description
    relatedUrl
    suggestedArtifactTitle
    suggestedCoreValue {
      id
    }
    coachingReportId
    coachingInsight {
      title
      body
      evidence {
        text
        sourceRef
        sourceUrl
        sourceTitle
      }
      action {
        label
        text
        variant
      }
      topics {
        title
        notes
      }
    }
  }
`;

export default gql`
  ${ProfileCoachingInsightFragment}
  query getProfileCoachingInsightsQuery($profileId: Int!) {
    user(userId: $profileId) {
      id
      managerInsights {
        edges {
          node {
            ...ProfileCoachingInsightFragment
          }
        }
      }
    }
  }
`;
